import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ArrowRoundedLeft8x13Svg, ArrowRoundedRight8x13Svg } from '../../svg';

class Pagination extends Component {
    setPage = (value) => {
        const { total, current, onPageChange } = this.props;

        if (value < 1 || value > total || value === current) {
            return;
        }

        if (onPageChange) {
            onPageChange(value);
        }
    };

    onClick = () => {
        const { noScrollTop } = this.props;
        if (noScrollTop === 'false' || noScrollTop === null) {
            try {
                window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            } catch {
                window.scrollTo(0, 0);
            }
        }
    };

    getPages() {
        const { siblings, current, total } = this.props;
        const pages = [];
        const min = Math.max(1, current - siblings - Math.max(0, siblings - total + current));
        const max = Math.min(total, min + siblings * 2);

        for (let i = min; i <= max; i += 1) {
            pages.push(i);
        }

        return pages;
    }

    render() {
        const { current, total } = this.props;
        const firstLinkClasses = classNames('page-item', {
            disabled: current <= 1,
        });
        const lastLinkClasses = classNames('page-item', {
            disabled: current >= total,
        });

        const pages = this.getPages().map((page, index) => {
            const classes = classNames('page-item', {
                active: page === current,
            });

            return (
                <li key={index} className={classes}>
                    <button
                        type="button"
                        className="page-link"
                        onClick={() => {
                            this.onClick();
                            this.setPage((page));
                            // setTimeout(() => {
                            //     this.setPage(page);
                            // }, 10000);
                        }}
                    >
                        {page}
                        {page === current && <span className="sr-only">(current)</span>}
                    </button>
                </li>
            );
        });

        return (
            <ul className="pagination justify-content-center">
                <li className={firstLinkClasses}>
                    <button
                        type="button"
                        className="page-link page-link--with-arrow"
                        aria-label="Previous"
                        onClick={() => {
                            this.onClick();
                            this.setPage(current - 1)
                        }}
                    >
                        <ArrowRoundedLeft8x13Svg className="page-link__arrow page-link__arrow--left" aria-hidden="true" />
                    </button>
                </li>
                {pages}
                <li className={lastLinkClasses}>
                    <button
                        type="button"
                        className="page-link page-link--with-arrow"
                        aria-label="Next"
                        onClick={() => {
                            this.onClick();
                            this.setPage(current + 1)
                        }}
                    >
                        <ArrowRoundedRight8x13Svg className="page-link__arrow page-link__arrow--right" aria-hidden="true" />
                    </button>
                </li>
            </ul>
        );
    }
}

Pagination.propTypes = {
    siblings: PropTypes.number,
    current: PropTypes.number,
    total: PropTypes.number,
    onPageChange: PropTypes.func,
    noScrollTop: PropTypes.string,
};

Pagination.defaultProps = {
    siblings: 1,
    current: 1,
    total: 1,
    noScrollTop: 'false',
};

export default Pagination;
